import { createContext } from "react";

export const TimeZoneContext = createContext<string>("Asia/Tokyo");
